(() => {
  if (customElements.get("slich-restock-alert")) return;
  const origin = "https://geoprint-shopify.vercel.app";
  customElements.define("slich-restock-alert", class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.select = this.querySelector("select");
      this.link = this.querySelector("a");
      if (!this.select || !this.link || !/^[a-z0-9][a-z0-9-]{0,99}$/.test(this.dataset.handle ?? "")) return;
      this.select.addEventListener("change", () => this.updateLink(), { signal: this.controller.signal });
      this.refresh = () => this.load();
      window.addEventListener("focus", this.refresh, { signal: this.controller.signal });
      this.timer = setInterval(this.refresh, 60000);
      void this.load();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
    }
    updateLink() {
      const url = new URL("/retour-en-stock", origin);
      url.searchParams.set("produit", this.dataset.handle);
      url.searchParams.set("variante", this.select.value);
      this.link.href = url.href;
    }
    async load() {
      if (this.loading || !this.isConnected) return;
      this.loading = true;
      try {
        const response = await fetch(`${origin}/api/catalogue/disponibilite?produit=${encodeURIComponent(this.dataset.handle)}`, {
          cache: "no-store", credentials: "omit", signal: this.controller.signal
        });
        if (!response.ok) throw new Error("unavailable");
        const data = await response.json();
        if (data.handle !== this.dataset.handle || !Array.isArray(data.variants)) throw new Error("invalid");
        const variants = data.variants.filter(v => (this.dataset.handle !== "eco-cup-personnalise" || v.options.length < 3 || v.options[2] === "1 gobelet") && v.available === false && /^\d{1,30}$/.test(v.id) && typeof v.title === "string");
        this.hidden = data.alertsEnabled !== true || variants.length === 0;
        if (this.hidden) return;
        const previous = this.select.value || new URL(location.href).searchParams.get("variant");
        this.select.replaceChildren(...variants.map(v => {
          const option = document.createElement("option");
          option.value = v.id;
          option.textContent = v.title;
          return option;
        }));
        if (variants.some(v => v.id === previous)) this.select.value = previous;
        this.updateLink();
      } catch {
        this.hidden = true;
      } finally {
        this.loading = false;
      }
    }
  });
})();
